module.exports = __webpack_public_path__ + "static/3-membership-benefit-d4190e33653dbcac4cc931adde360e5f.png";